import script from "./MemberProfileConfPage.vue?vue&type=script&setup=true&lang=js"
export * from "./MemberProfileConfPage.vue?vue&type=script&setup=true&lang=js"

import "./MemberProfileConfPage.vue?vue&type=style&index=0&id=541f535e&scoped=true&lang=css"

import exportComponent from "F:\\workspace\\eduwind-front\\eduwind-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-541f535e"]])

export default __exports__